import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withHouseholdContextAdapter } from 'Context/SimpleHouseholdContext';
import TextField from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/TextField';

import './index.css';

const notesPlaceholder = 'Add internal notes here. These notes will not be displayed on the client timeline.';

class DashboardNotes extends Component {
  constructor(props) {
    super(props);
    const { SimpleHouseholdContext } = this.props;
    const { householdResource } = SimpleHouseholdContext;

    this.state = {
      value: householdResource.attr('dashboardNotes'),
      isDirty: false,
    };

    this.onUpdate = this.onUpdate.bind(this);
    this.onWrite = this.onWrite.bind(this);
  }

  onUpdate(value) {
    this.setState({ value, isDirty: true });
  }

  onWrite() {
    const { SimpleHouseholdContext } = this.props;
    const { householdResource, updateHousehold } = SimpleHouseholdContext;
    const { isDirty, value } = this.state;

    // If the field hasn't changed then don't save
    if (!isDirty) {
      return;
    }

    this.setState({ isDirty: false });

    // Short circuit, no update necessary
    if (value === undefined) {
      return;
    }

    const updatedHouseholdResource = householdResource.copy().attr('dashboardNotes', value);

    updateHousehold(updatedHouseholdResource.export());
  }

  render() {
    const { onUpdate, onWrite } = this;
    const { value } = this.state;

    return (
      <div className="DashboardNotes">
        <h4 className="title">Notes</h4>
        <TextField
          name="dashboardNotes"
          placeholder={notesPlaceholder}
          value={value}
          multiline
          rows={4}
          rowsMax={10}
          onChange={onUpdate}
          onBlur={onWrite}
          variant="outlined"
        />
      </div>
    );
  }
}

DashboardNotes.propTypes = {
  SimpleHouseholdContext: PropTypes.object.isRequired,
};

export default withHouseholdContextAdapter(DashboardNotes);
